// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "1830") return "js/1830." + __webpack_require__.h() + ".js";
if (chunkId === "310") return "js/310." + __webpack_require__.h() + ".js";
if (chunkId === "5980") return "js/5980." + __webpack_require__.h() + ".js";
if (chunkId === "9095") return "js/9095." + __webpack_require__.h() + ".js";
  // return url for filenames based on template
  return "js/" + chunkId + "." + __webpack_require__.h() + ".chunk.js"
}